import { render, staticRenderFns } from "./PaymentYearSelectbox.vue?vue&type=template&id=2d4c23e6"
import script from "./PaymentYearSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentYearSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports